import React, { useState, useEffect } from 'react';

import Loading from '@common/components/Loading/Loading';

import CraftEditor from './components/CraftEditor';

import { useTemplateDetailsStore } from '@store/templateDetailsStore';
import useCurrentLanguageEditorState from '@hooks/useCurrentLanguageEditorState';
import EditorHeader from './components/EditorHeader';
import CustomEmailEditorHeader from './components/CustomEmailEditorHeader';

const CustomEmail = () => {
  const [isLoading, setIsLoading] = useState(true);

  const setTemplateDetailsInCustomEmail = useTemplateDetailsStore(
    (s) => s.setTemplateDetailsInCustomEmail,
  );

  const { currentLanguageEditorState, currentLanguage, source } =
    useCurrentLanguageEditorState();

  useEffect(() => {
    const fetchTemplateDetails = async () => {
      setIsLoading(true);
      try {
        await setTemplateDetailsInCustomEmail();
      } catch (err) {
        console.log('err: ', err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTemplateDetails();
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      {currentLanguageEditorState?.id && source?.structure && (
        <>
          <CustomEmailEditorHeader />
          <CraftEditor
            key={currentLanguageEditorState?.language}
            jsonData={currentLanguageEditorState?.jsonData}
            setSaveLoading={setIsLoading}
            templateSubject={currentLanguageEditorState?.subject}
            currentLanguage={currentLanguage}
            isCustomEmail={true}
          />
        </>
      )}
    </>
  );
};

export default CustomEmail;
